import React, {useEffect, useState} from 'react';
import {Button, Dropdown, Input, MenuProps, message, Modal, Space, Typography} from 'antd';
import {DownOutlined} from '@ant-design/icons';
import Config from "./Config";
import Cart from "./Cart";
import {showUsageInfo} from "./UsageInfo";
import TokenModal from "./TokenModal";

const {Paragraph, Text} = Typography;

export interface LoginInfo {
  message?: string;
  detail?: Detail;
  success?: boolean;
  email?: string;
  isSuccess?: boolean;
}

export interface Detail {
  id: number;
  username: string;
  currentAuthority: string;
  sign: null;
  config: string;
  vipEndTime: Date;
  host: string;
  isActiveVip: boolean;
  vip: boolean;
  watermask: string;
}


const Login: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [email, setEmail] = useState('')
  const [showConfig, setShowConfig] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [showTokenModal, setShowTokenModal] = useState(false);

  const [userInfo, setUserInfo] = useState<LoginInfo>({})


  useEffect(() => {
    fetch('/login/info', {
      method: 'GET',
    }).then(res => res.json()).then((e) => {
      console.info(e)
      if (e.isSuccess) {
        setUserInfo(e)
      }
    })
  }, [])

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    if (email.trim() === '') {
      message.error('请输入邮箱')
      return
    }

    if (!email.includes('@')) {
      if (email.includes(' ')) {
        // 这里用户可能输入的是激活卡号密码
        message.error('请输入正确的邮箱，系统会发送激活链接到您的邮箱中，登录成功后在右上角使用卡密进行激活。卡密在购买成功页面上。')
      } else {
        message.error('请输入正确的邮箱')
      }

      return;
    }

    // 发送登录链接
    fetch('/login/email', {
      method: 'POST',
      body: JSON.stringify({
        email: email.trim(),
        host: window.location.host,
      }),
      headers: {
        'Content-Type': 'application/json;charset=utf8'
      }
    }).then(res => res.json()).then((e) => {
      console.info(e)
      if (e.isSuccess) {
        message.info(e.message || '请查收邮箱进行登录')
        setIsModalOpen(false)
      } else {
        message.error(e.message || '发送失败，请稍后再试')
      }
    })
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleViewToken = () => {
    setShowTokenModal(true);
  };

  const items: MenuProps['items'] = [
    {
      key: '0',
      label: (
        "设置"
      ),
      onClick: (e) => {
        setShowConfig(true);
      }
    },
    {
      key: '1',
      label: (
        "购买VIP(或激活VIP)"
      ),
      onClick: (e) => {
        setShowCart(true);
      }
    },
    {
      key: '2',
      label: (
        "查看使用情况"
      ),
      onClick: (e) => {
        showUsageInfo();
      }
    },
    {
      key: '3',
      label: (
        "查看 Token"
      ),
      onClick: (e) => {
        handleViewToken();
      }
    },
    {
      key: '999',
      label: (
        "退出"
      ),
      onClick: (e) => {
        fetch('/login/logout', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf8'
          }
        }).then(res => res.json()).then((e) => {
          setUserInfo({});
          message.success(e.message || "您已成功退出")
        })
      }
    },
  ];

  return (
    <>
      {
        userInfo && userInfo.email && (
          <>
            {
              userInfo && !userInfo.detail?.isActiveVip && (
                <Button color="danger" type="link" onClick={() => setShowCart(true)}>
                  激活会员
                </Button>
              )
            }
            <Dropdown menu={{items}}>
              <button
                onClick={(e) => e.preventDefault()}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}>
                <span style={{
                  "height": "20px",
                  "fontFamily": "PingFangSC",
                  "fontWeight": 400,
                  "fontSize": "12px",
                  "color": "rgb(76, 83, 98)",
                  "lineHeight": "20px"
                }}>{userInfo.email}</span>
                <DownOutlined style={{ fontSize: '10px', color: 'rgb(76, 83, 98)' }} />
              </button>
            </Dropdown>
          </>
        )
      }

      {
        !userInfo?.email && (
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              showModal();
            }}
            style={{
              "height": "20px",
              "fontFamily": "PingFangSC",
              textDecoration: 'none',
              cursor: 'pointer',
              "fontWeight": 400,
              "fontSize": "12px",
              "color": "#4C5362",
              "lineHeight": "20px"
            }}
          >
            登录
          </a>
        )
      }
      <Modal title="登录" open={isModalOpen} onCancel={handleCancel} cancelText={"取消"} okText={"发送登录链接"}
             onOk={handleOk}>
        <Space.Compact style={{width: '100%'}}>
          <Input defaultValue="请输入邮箱" placeholder={"请输入邮箱"} value={email}
                 onChange={e => setEmail(e.target.value)} type={'email'}/>
        </Space.Compact>
        <br/>
        <Paragraph>
          <Text type={'danger'} strong underline>
            请输入您的邮箱地址
          </Text>
          ，系统将发送
          <Text strong>
            登录链接
          </Text>
          到您的邮箱中。
          <Text underline strong type={'danger'}>如果需要激活会员</Text>，请登录后使用卡密进行激活。
        </Paragraph>
      </Modal>

      <Modal title="设置中心" footer={null} open={showConfig} okText={"关闭"} cancelText={"关闭"}
             onCancel={() => setShowConfig(false)} onOk={() => {
        setShowConfig(false)
      }}>
        <Config/>
      </Modal>

      <Modal title="VIP 中心" footer={null} width={"80%"} open={showCart} okText={"关闭"} cancelText={"关闭"}
             onCancel={() => setShowCart(false)} onOk={() => {
        setShowCart(false)
      }}>
        <Cart/>
      </Modal>

      <TokenModal 
        open={showTokenModal} 
        onCancel={() => setShowTokenModal(false)} 
      />
    </>
  );
};

export default Login;